import { HttpParams } from '@angular/common/http';
import { IChoosenFilterInterface } from 'app/library/all-users/interfaces/choosen-filter.interface';
import { IModuleUserDateRangeFilters } from '../interfaces/module-user-date-range-filters.interface';

function toDateFilterValue(value: string | number | undefined): string | null {
    if (value === undefined || value === null) {
        return null;
    }

    return String(value);
}

export function getModuleUserDateRangeFiltersFromChosenFilters(filters: IChoosenFilterInterface[]): IModuleUserDateRangeFilters {
    const createdOnFilter = filters.find((filter) => filter.entity.type === 'CreatedOn');
    const lastModifiedFilter = filters.find((filter) => filter.entity.type === 'LastModified');

    return {
        createdAtGte: toDateFilterValue(createdOnFilter?.rangeValue1),
        createdAtLte: toDateFilterValue(createdOnFilter?.rangeValue2),
        updatedAtGte: toDateFilterValue(lastModifiedFilter?.rangeValue1),
        updatedAtLte: toDateFilterValue(lastModifiedFilter?.rangeValue2),
    };
}
export function appendModuleUserDateRangeFilters(params: HttpParams, dateRangeFilters: IModuleUserDateRangeFilters): HttpParams {
    if (dateRangeFilters.createdAtGte) {
        params = params.set('filter[createdAt][gte]', dateRangeFilters.createdAtGte);
    }

    if (dateRangeFilters.createdAtLte) {
        params = params.set('filter[createdAt][lte]', dateRangeFilters.createdAtLte);
    }

    if (dateRangeFilters.updatedAtGte) {
        params = params.set('filter[updatedAt][gte]', dateRangeFilters.updatedAtGte);
    }

    if (dateRangeFilters.updatedAtLte) {
        params = params.set('filter[updatedAt][lte]', dateRangeFilters.updatedAtLte);
    }

    return params;
}
